import React from 'react'
import MessageUtils from '../../util/MessageUtils'
import './TextInput.css'

const TextInputUI = ({value, onChange, onSubmit, onCancel, messageList, placeholderKey, maxLength}) =>
  <div className='w_text_inp g_flex_h'>
    <input
      onChange={onChange}
      value={value}
      placeholder={placeholderKey && MessageUtils.getMessageValue(messageList, placeholderKey)}
      maxLength={maxLength ? maxLength : ''}
    />
    {
      onSubmit &&
      <div className='icon icon-check g_link' onClick={onSubmit} />
    }
    {
      onCancel &&
      <div className='icon icon-times g_link' onClick={onCancel} />
    }
  </div>

export default TextInputUI
